import produce from 'immer';

import { ExchangeSegmentsState } from '../types';
import type {
	SetSegmentsAction,
	ToggleSegmentAction,
	ToggleAllSegmentsAction,
	SetSegmentDateAction,
	ClearSegmentsDateAction,
	SetSegmentSelectPayload,
	SelectSegmentDatePayload
} from './actions';
import { setSegments, setSegmentDate, setAllSegmentsSelect, setSegmentSelect, clearSegmentsDate } from './actions';

const initialState: ExchangeSegmentsState = {};

function segmentsReducer(
	state = initialState,
	{
		type,
		payload
	}:
		| SetSegmentsAction
		| ToggleSegmentAction
		| ToggleAllSegmentsAction
		| SetSegmentDateAction
		| ClearSegmentsDateAction
) {
	return produce(state, draft => {
		switch (type) {
			case setSegments.toString():
				return payload;
			case setAllSegmentsSelect.toString():
				const actionPayload = payload as boolean;

				Object.keys(draft).forEach(key => (draft[key].isSelected = actionPayload));
				break;
			case setSegmentSelect.toString(): {
				const actionPayload = payload as SetSegmentSelectPayload;
				const isAllSegments = Object.values(draft).every(segment => segment.isSelected);

				if (isAllSegments) {
					Object.keys(draft).forEach(key => (draft[key].isSelected = false));
				}

				draft[actionPayload.id].isSelected = isAllSegments || actionPayload.selected;
				break;
			}
			case setSegmentDate.toString(): {
				const actionPayload = payload as SelectSegmentDatePayload;

				draft[actionPayload.id].selectedDate = actionPayload.date;
				break;
			}
			case clearSegmentsDate.toString():
				Object.keys(draft).forEach(key => (draft[key].selectedDate = undefined));
				break;
		}
	});
}

export default segmentsReducer;
